import {Component, OnInit} from '@angular/core';
import {ProjectService} from "./store/project.service";
import {environment} from "../environments/environment";
import {enableAkitaProdMode} from "@datorama/akita";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'as-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  constructor(
    private projectService: ProjectService,
  ) {
    if (environment.production) {
      enableAkitaProdMode();
    }
  }

  ngOnInit(): void {
    this.projectService.init();
  }
}
